module.exports = __webpack_public_path__ + "/build/web/images/matching-pillows.4762fa48811182c3f99b89b246b351bd.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/matching-pillows.jpg
// module id = 173
// module chunks = 13